import React, { Component } from 'react';
import Button from '@material-ui/core/Button';

import { withStyles } from '@material-ui/core/styles';
import {} from 'react-i18nify';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { Translate, translate } from 'react-i18nify';
import { account } from '../reducers/account';

const style = theme => ({
  statusBanner: {
    padding: '10px',
    fontSize: '15px',
    color: '#333333',
    backgroundColor: theme.statusColors.error,
    margin: '10px 15px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flex: 1,
  },
  statusMessage: {
    padding: '5px',
    alignText: 'center',
    flexGrow: 1,
  },
  statusHelpMesage: {
    paddingTop: '10px',
  },
  button: {
    display: 'flex',
    gap: 2,
  },
});

class StatusBannerComponent extends Component {
  render() {
    const {
      classes,
      accountId,
      showButton = false,
      migrateRedirect,
      readOnlyDate,
      readOnlyState,
      generateMigrateLink,
      isMigrated,
    } = this.props;

    const redirectSecureEdge = () => {
      window.location.href = migrateRedirect[accountId].url;
    };

    const migrate_btn = () => {
      generateMigrateLink({
        account_id: accountId,
        individual: true,
      });
    };

    const statusMessage = showButton
      ? 'components.migrationToSecureEdge.migrateStatusmessageRedirect'
      : 'components.migrationToSecureEdge.migrateStatusMessageRedirectMSP';

    const readOnlyMessage = readOnlyState
      ? 'components.migrationToSecureEdge.migrateStatusMessageReadOnly'
      : 'components.migrationToSecureEdge.migratedMessage';

    return (
      <Box className={classes.statusBanner}>
        <Box className={classes.statusMessage}>
          {migrateRedirect[accountId] ? (
            <Translate
              value={`components.migrationToSecureEdge.${
                migrateRedirect[accountId].action
              }Message`}
            />
          ) : (
            <Box>
              {!showButton ? (
                <Box className={classes.statusHelpMesage}>
                  <Translate value={statusMessage} />
                </Box>
              ) : isMigrated ? (
                translate(readOnlyMessage, { date: readOnlyDate })
              ) : (
                <Translate value="components.migrationToSecureEdge.migrateStatusMessageRedirect" />
              )}
              <Box className={classes.statusHelpMesage}>
                <Translate value="components.migrationToSecureEdge.secureEdgeInformation" />
              </Box>
            </Box>
          )}
        </Box>
        {!isMigrated && showButton && (
          <Box className={classes.button}>
            <Button
              onClick={() => {
                migrateRedirect === '' ? migrate_btn() : redirectSecureEdge();
              }}
              disabled={
                migrateRedirect[accountId]
                  ? migrateRedirect[accountId].action === 'prepare'
                  : false
              }
              variant="contained"
              color="secondary"
            >
              {migrateRedirect[accountId] ? (
                <Translate
                  value={`components.migrationToSecureEdge.${
                    migrateRedirect[accountId].action
                  }Button`}
                />
              ) : (
                <Translate value="components.migrationToSecureEdge.migrateButton" />
              )}
            </Button>
          </Box>
        )}
      </Box>
    );
  }
}

export default withStyles(style, { name: 'StatusBanner' })(
  StatusBannerComponent
);
